import type {
  ApiResponse,
  cancelSourcingApplicationSchema,
  PageResponse,
  SaveAndApplySourcingRequirementSchema,
  SourcingType,
  SrmPurchaseRequestDetailVo,
  SrmPurchaseRequestDto,
  SrmPurchaseRequestListQueryDto,
  SrmPurchaseRequestTypeTreeVo,
  SrmPurchaseRequestVo,
  SrmSourcingApplicationItemDetail,
  SrmSourcingApplicationListItem,
  UpdateScourcingNodeSchema,
} from "@/types/apis";
import request from "@/utils/request";

/**
 * 寻源列表
 * @param data
 * @returns
 */
export const getSrmSourcingApplicationList = (data: any) =>
  request.post<PageResponse<SrmSourcingApplicationListItem>>(
    "/purchase/sourcing/application/pageList",
    data,
  );

/**
 * 获取寻源类别信息
 */
export const getSourcingTypeEnums = () =>
  request.get<ApiResponse<SourcingType[]>>(
    "/purchase/sourcing/application/getSourcingTypeEnums",
  );

/**
 *  保存并申请-寻源申请
 */
export const saveAndApplySourcingRequirement = (
  data: Partial<SaveAndApplySourcingRequirementSchema>,
) => request.post("/purchase/sourcing/application/saveAndApply", data);

/**
 * 根据ID获取寻源申请详情
 */
export const getSourcingRequirementDetail = (id: number) =>
  request.get<ApiResponse<SrmSourcingApplicationItemDetail>>(
    `/purchase/sourcing/application/detail/${id}`,
  );

/**
 * 删除寻源申请
 */
export const deleteSourcingRequirementRecord = (ids: number[]) =>
  request.post<ApiResponse>("/purchase/sourcing/application/delete", ids);

/** 下载生产性物料寻源计划模板 1, 非生产性物料寻源计划模板 2 */
export const downloadSourcingPlanTemplate = (type: 1 | 2) => {
  const path =
    type === 1
      ? "/purchase/sourcing/application/importTemplate/production"
      : "/purchase/sourcing/application/importTemplate/nonProduction";
  return request.post(
    path,
    {},
    {
      responseType: "blob",
    },
  );
};

/** 更新寻源物料信息  */
export const updateSourcingMaterial = (
  data: Array<{
    id: number;
    /** 寻源方法 */
    sourcingMethod?: number;
    /** 寻源来源 */
    sourcingOrigin?: number;
    /** 计划开始时间 */
    plannedStartTime?: string;
    /** 计划结束时间 */
    plannedEndTime?: string;
  }>,
) =>
  request.post<ApiResponse>(
    "/purchase/sourcing/application/updateSourcingMaterial",
    data,
  );

/** 导入生产性物料寻源计划  */
export const importProductionSourcingPlan = (data: FormData) =>
  request.post<ApiResponse>(
    "/purchase/sourcing/application/importData/production",
    data,
  );

/** 导入非生产性物料寻源计划  */
export const importNonProductionSourcingPlan = (data: FormData) =>
  request.post<ApiResponse>(
    "/purchase/sourcing/application/importData/nonProduction",
    data,
  );

/**
 * 取消指定物料寻源
 */
export const cancelSourcingMaterial = (data: cancelSourcingApplicationSchema) =>
  request.post<ApiResponse>(`/purchase/sourcing/application/cancel`, data);

/**
 * 更新节点信息
 */
export const updateSourcingNode = (data: UpdateScourcingNodeSchema) =>
  request.post<ApiResponse>("/purchase/sourcing/application/updateNode", data);

/** 采购申请分页查询 */
export const getPurchaseRequestPage = (data: SrmPurchaseRequestListQueryDto) =>
  request.post<PageResponse<SrmPurchaseRequestVo>>(
    "/purchase/request/pageList",
    data,
  );

/** 采购申请-根据ID获取采购申请详情 */
export const getPurchaseRequestDetail = (id: number) =>
  request.get<ApiResponse<SrmPurchaseRequestDetailVo>>(
    `/purchase/request/detail/${id}`,
  );

/** 删除采购申请 */
export const deletePurchaseRequest = (ids: number[]) =>
  request.post<ApiResponse>("/purchase/request/delete", ids);

/** 获取采购申请类型结构树 */
export const getPurchaseRequestTypeTree = () =>
  request.get<ApiResponse<SrmPurchaseRequestTypeTreeVo[]>>(
    "/purchase/request/typeTree",
  );

/** 保存并申请采购申请 */
export const saveAndApplyPurchaseRequest = (data: SrmPurchaseRequestDto) =>
  request.post<ApiResponse>("/purchase/request/saveAndApply", data);

/** 生成PR编号 */
export const generatePurchaseRequestPRNo = (id: number) =>
  request.post<ApiResponse>(`/purchase/request/generatePrNo/${id}`);
